import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import { API_BASE_URL, IMAGE_URL } from "../utils/app_url";
import VendorHeader from "../component/VendorHeader";
import VendorFooter from "../component/VendorFooter";
import Sidebar from "../component/Sidebar";
import { useLanguage } from "../context/LanguageContext";
import { useAuth } from "../context/AuthContext";

const PhotoOrderDetails = () => {
    const { id } = useParams();
    const { user } = useAuth();
    const { langJson } = useLanguage();
    const navigate = useNavigate();
    const [order, setOrder] = React.useState(null);
    const [loading, setLoading] = React.useState(false);

    React.useEffect(() => {
        const fetchOrder = async () => {
            setLoading(true);
            try {
                const token = localStorage.getItem("token");
                const response = await fetch(
                    `${API_BASE_URL}order/store-photo-orders/${id}`,
                    {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: `Bearer ${user?.authorisation?.token}`,
                        },
                    }
                );
                const res = await response.json();
                if (res?.res && res.data) {
                    setOrder(res.data);
                } else {
                    setOrder(null);
                }
            } catch (err) {
                setOrder(null);
            } finally {
                setLoading(false);
            }
        };
        fetchOrder();
    }, [id]);

    return (
        <div>
            <div className="dashHeader">
                <VendorHeader />
            </div>
            <div className="adminDash">
                <Sidebar />
                <div className="rightSide">
                    <h2>Photo Order Details</h2>
                    <div className="addProductForm">
                        {loading && (

                            <p>Loading...</p>

                        )}


                        {!loading && order && (
                            <>
                                    <img
                                        src={order.image ? `${IMAGE_URL}/${order.image}` : undefined}
                                        alt={order.title}
                                        className="photo-order-image"
                                    />
                                <ul className="addAddress photoOrder">

                                    <li>
                                        <label>Order Number</label>
                                        <p>{order.order_number}</p>
                                    </li>
                                    <li>
                                        <label>Title</label>
                                        <p>{order.title}</p>
                                    </li>
                                    <li>
                                        <label>Description</label>
                                        <p>{order.description}</p>
                                    </li>
                                    <li>
                                        <label>Size</label>
                                        <p>{order.size}</p>
                                    </li>
                                    <li>
                                        <label>Quantity</label>
                                        <p>{order.quantity}</p>
                                    </li>
                                    <li>
                                        <label>Status</label>
                                        <p>{order.status}</p>
                                    </li>
                                    <li>
                                        <label>Payment Method</label>
                                        <p>{order.payment_method}</p>
                                    </li>
                                    <li>
                                        <label>Payment Status</label>
                                        <p>{order.payment_status}</p>
                                    </li>
                                    <li>
                                        <label>Ordered Date</label>
                                        <p>{order.ordered_date}</p>
                                    </li>
                                    <li>
                                        <label>Name</label>
                                        <p>{order.name}</p>
                                    </li>
                                    <li>
                                        <label>Email</label>
                                        <p>{order.email}</p>
                                    </li>
                                    <li>
                                        <label>Phone</label>
                                        <p>{order.phone}</p>
                                    </li>
                                    <li className="fullWidth">
                                        <label>Address</label>
                                        <p>{order.address}, {order.city}, {order.state}, {order.country}, {order.zip_code}</p>
                                    </li>
                                    <li className="fullWidth">
                                        <label>Remarks</label>
                                        <p>{order.remarks}</p>
                                    </li>

                                </ul>
                            </>
                        )}
                        {!loading && !order && (

                            <p>Order not found.</p>

                        )}

                    </div>
                    <div className="fullWidth saveBtn addAddress">
                        <button className="backLink" onClick={() => navigate(-1)}>&larr; Back</button>
                    </div>
                </div>
            </div>
            <VendorFooter />
        </div >
    );
};

export default PhotoOrderDetails;
